import { render, staticRenderFns } from "./admin-certificates.vue?vue&type=template&id=5f61ac1e&scoped=true"
import script from "./admin-certificates.vue?vue&type=script&lang=js"
export * from "./admin-certificates.vue?vue&type=script&lang=js"
import style0 from "./admin-certificates.vue?vue&type=style&index=0&id=5f61ac1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f61ac1e",
  null
  
)

export default component.exports